






import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { FixedLoading } from "../../system";
import { FixedPhraseRootReference } from "../../../domain/document";
import FixedPhraseTreeSelector from "./FixedPhraseTreeSelector.vue";
import { FixedPhraseTreeSelectorMixin } from "./mixins";
import { IEditFixedPhrase } from "./IEditFixedPhrase";
import { FixedPhraseKinds } from "./FixedPhraseKinds";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
  }
})
export default class DepartmentFixedPhraseSelector extends Mixins(
  FixedPhraseTreeSelectorMixin,
) implements IEditFixedPhrase {
  @Prop()
  departmentId: string;

  @Prop({ default: true })
  isPastable: boolean;

  async created(): Promise<void> {
    await this.loadRootFixedPhrase();
  }

  mounted(): void {
    this.selector = this.$refs.selector;
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    return this.executeWithManagementTokenControll("定型文", isForcibly => this.getManagementToken(FixedPhraseKinds.Department, isForcibly, this.departmentId), this.executeEditFixedPhrase);
  }

  private async executeEditFixedPhrase(): Promise<void> {
    const latest = await this.getFixedPhrase(FixedPhraseKinds.Department, this.departmentId);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.Department, this.departmentId);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.Department, result);
  }

  private async loadRootFixedPhrase(): Promise<void> {
    if (this.departmentId === null) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      return;
    }
    try {
      this.rootFixedPhrase = await this.getFixedPhrase(FixedPhraseKinds.Department, this.departmentId);
    } catch (e) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "主" + this.$wording.common.departmentAsShort + "定型文取得失敗",
        "主" + this.$wording.common.departmentAsShort + "定型文を読み込めませんでした。",
        e);
    }
  }
}
